module.exports = __webpack_public_path__ + "static/assets/aa7be91da68486f7e8948f617fb89f33.svg";